/* eslint-disable react-intl/string-is-marked-for-translation */
import { TweenMax } from 'gsap';

import { createElement, Component } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import getYoutubeConfig from 'helpers/youtube/getYoutubeConfig';
import insertYoutubeApiScript from 'helpers/youtube/insertYoutubeAPIScript';

export default class HomePageSplash extends Component {

  componentDidMount () {
    TweenMax.set(document.querySelector('#homepage-video'), {autoAlpha: 0});
    this.loadYT = new Promise(resolve => {
      insertYoutubeApiScript();
      window.onYouTubeIframeAPIReady = () => resolve(window.YT);
    }).then(YT => {
      this.player = new YT.Player(
        'homepage-video',
        getYoutubeConfig('bTeACeGAFwg')
      );
    });
  }

  render () {
    return (
      <div className="homepage-splash">
        <div className="homepage-video-wrapper pattern-overlay">
          <div className="pattern" />
          <div id="homepage-video" />
        </div>
        <div className="content">
          <h1 title="Game with us." className="site-slogan text-center">
            Game with us.
          </h1>
        </div>

      </div>
    );
  }
}

themeable(HomePageSplash, {
  classes: [
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/SplashScreen/HomePageSplash.jsx